import { render, staticRenderFns } from "./MerchantSettledList.vue?vue&type=template&id=0f1a4c78&scoped=true&"
import script from "./MerchantSettledList.vue?vue&type=script&lang=js&"
export * from "./MerchantSettledList.vue?vue&type=script&lang=js&"
import style0 from "./MerchantSettledList.vue?vue&type=style&index=0&id=0f1a4c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1a4c78",
  null
  
)

export default component.exports